// Turn file inputs and drag-and-drop payloads (including whole folders)
// into [{ file, relativePath }] for the upload queue.

export const filesFromInput = (fileList) =>
  Array.from(fileList || []).map((file) => ({
    file,
    // Set by <input webkitdirectory>: "Folder/Sub/file.jpg"
    relativePath: file.webkitRelativePath || '',
  }));

const readAllEntries = (reader) =>
  new Promise((resolve, reject) => {
    const all = [];
    const next = () => reader.readEntries((batch) => {
      if (!batch.length) return resolve(all);
      all.push(...batch);
      next();
    }, reject);
    next();
  });

const walk = async (entry, prefix, out) => {
  if (entry.isFile) {
    const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
    out.push({ file, relativePath: prefix ? `${prefix}/${file.name}` : '' });
  } else if (entry.isDirectory) {
    const path = prefix ? `${prefix}/${entry.name}` : entry.name;
    const children = await readAllEntries(entry.createReader());
    for (const child of children) {
      await walk(child, path, out);
    }
  }
};

export const filesFromDrop = async (dataTransfer) => {
  // Read both views now: the DataTransfer is emptied once the drop event returns
  const plain = filesFromInput(dataTransfer.files);
  const items = Array.from(dataTransfer.items || []);
  const entries = items.map((item) => item.webkitGetAsEntry?.()).filter(Boolean);
  if (!entries.length) return plain;
  const out = [];
  for (const entry of entries) {
    try {
      await walk(entry, '', out);
    } catch {
      // Safari can refuse entry.file() ("NotFoundError"), e.g. for videos dragged from
      // Photos or iCloud placeholders: fall back to the plain file of the same name
      const same = plain.find((p) => p.file.name === entry.name);
      if (same && !out.some((o) => o.file === same.file)) out.push(same);
    }
  }
  return out.length ? out : plain;
};

export const isFileDrag = (e) => Array.from(e.dataTransfer?.types || []).includes('Files');
